<template>
  <proa-card
    class="cafe-room-card d-flex flex-column text-secondary clickable"
    @click.native="onClickCafeRoom"
  >
    <div class="d-flex justify-content-between px-3 pt-3">
      <div class="room-name">
        <img :src="require('@/assets/images/icons/cafe.png')" />
        <span>{{ $t('pages.mySpace.cafe') }}</span>
      </div>
      <div class="room-capacity">{{ $t('common.max') + cafeRoom.roomCapacity + $t('common.person') }}</div>
    </div>
    <div class="d-flex flex-row align-items-center justify-content-center flex-grow-1">
      <div class="in-duration">
        <div v-for="user in currentCafeInfoUsers.visibleUsers" :key="user.id" class="avatar-wrapper">
          <proa-avatar :src="user.meta.avatar || require('@/assets/images/avatar_default.png')" size="sm"/>
        </div>
        <div
          v-if="currentCafeInfoUsers.omitted"
          class="omitted"
        >
          <span>{{ $t('common.threePointReader') }}</span>
          <span class="font-weight-w6">{{ currentCafeInfoUsers.count + $t('common.person') }}</span>
        </div>
      </div>
    </div>
  </proa-card>
</template>

<script>
export default {
  name: 'CafeRoomCard',
  props: {
    cafeRoom: Object
  },
  computed: {
    currentCafeInfoUsers: function() {
      const users = this.cafeRoom.getCurrentCafeInfoUsers()
      const visibleUsers = users.filter((_, i) => i < 9)
      return {
        visibleUsers: visibleUsers,
        omitted: visibleUsers.length != users.length,
        count: users.length
      }
    }
  },
  methods: {
    onClickCafeRoom: function() {
      this.$router.push({ name: 'indexMeetingReservations', params: { id: this.cafeRoom.id, returnPath: 'my_space' } })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.cafe-room-card {
  text-align: center;
  margin-right: 10px;
  width: 100%;
  height: 200px;

  &:hover {
    background-color: $light-gray-color;
  }

  @include mq(md) {
    width: 250px;
    height: 150px;
  }

  .room-name {
    font-weight: 600;
    display: flex;

    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }

  .room-capacity {
    font-weight: 600;
    font-size: 11px;
  }

  .in-duration {
    display: flex;
    flex-wrap: wrap;
    align-self: flex-start;
    width: 100%;
    padding: 15px 10px 15px 15px;

    .avatar-wrapper {
      margin: 0 5px 5px 0;
    }
  }

  .omitted {
    flex-grow: 1;
    padding: 5px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 11px;
  }
}
</style>
